var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentNew16PxImportable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95a5a6",
    d: "M5 0c-.982 0-3 2.018-3 3v10c0 1 1 2 2 2h8c.982 0 .762-1.048 1-2V5L9 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdc3c7",
    d: "M4 0c-.982 0-2 1.018-2 2v10c0 .982 1.018 2 2 2h8c.982 0 1.73-1.056 2-2V5L9 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#95a5a6",
    d: "M14 5L9 0v3c0 .982 1.018 2 2 2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 9.225 -504.681)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.55,
    cy: 1034.362,
    r: 7,
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.55,
    cy: 1032.362,
    r: 7,
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27ae60",
    d: "M1.55 1035.362h4v4h2v-4h4v-2h-4v-4h-2v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M1.55 1033.362h4v4h2v-4h4v-2h-4v-4h-2v4h-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNew16PxImportable);
export default __webpack_public_path__ + "static/media/document-new-16px-importable.2ded795ab32c25bff7a7709872b5df2e.svg";
export { ForwardRef as ReactComponent };